function formatNullValue(value) {
    if (value) {
        return value.trim();
    }

    return '';
}

export default formatNullValue;
